import React from "react";
import { IndividualEvent } from "./components/individualEvent/individualEvent.index";
import styles from "./eventHistory.module.css";
import { ApplicationEventHistoryFE } from "../../../../../../Models/applicationModels";
import { EVENT_TYPES } from "./eventHistory.constants";
import { Timeline } from "./components/timeline/timeline.index";
import { ErrorSection } from "../../../../../../Components/errorSection/errorSection.index";

interface EventHistoryProps {
    eventHistoryDetails: ApplicationEventHistoryFE | null;
    onRetry: () => void;
}

export const EventHistory = ({ eventHistoryDetails, onRetry }: EventHistoryProps) => {
    if(!eventHistoryDetails) {
        return <ErrorSection handleClick={onRetry} />

    }

    const { application, eventsResponse } = eventHistoryDetails;
    const { totalEvents, nextExpectedEvent, applicationEventHistory } = eventsResponse;
    const canRenderEvents = totalEvents > 0 && applicationEventHistory.length > 0;
    return (
        <div className={styles.eventHistoryContainer}>
            {canRenderEvents ? (
                <>
                    <div className={styles.headerContainer}>
                        <div className={styles.headerTextContainer}>Application: {application || "-"}</div>
                        <div className={styles.headerTextContainer}>Next Event: <span className={styles.nextEventText}>{nextExpectedEvent || "-"}</span></div>
                    </div>
                    <div className={styles.eventsContainer}>
                        {[...applicationEventHistory].reverse().map((event, index) => {
                            return (
                                <div key={`${event.eventName}-${event.createdOn}-${index}`} className={styles.eventRow}>
                                    <div className={styles.timelineColumn}>
                                        <Timeline eventType={event.eventType as EVENT_TYPES} />
                                    </div>
                                    <div className={styles.eventsColumn}>
                                        <IndividualEvent event={event} />
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </>
            ) : (
                <div className={styles.noEventsText}>No events found</div>
            )}
        </div>
    )
}
